const executeInterception = (
  entries,
  observer,
  params,
) => entries.forEach((entry) => {
  if (entry.isIntersecting) {

    params.callback();

    if (params.unobserve) {
      observer.unobserve(entry.target);
    }
  } else if (params.exitCallback) {
    params.exitCallback();
  }
});

/**
 * Creates the interceptor for the node
 * indicated in the parameter indicated as slide
 * @param {Node} element - element container slider
 * @param {Function} callback - callback when entering viewport
 * @param {Object} [options] - additional options
 * @param {Function} [options.exitCallback] - optional callback when exiting viewport
 */
export const createInterception = (
  element,
  callback,
  options = { root: null, rootMargin: "120px", unobserve: true },
) => {
  const optionsRoot = { ...options };
  const unobserve = optionsRoot.unobserve || false;
  const exitCallback = optionsRoot.exitCallback;


  delete optionsRoot.unobserve;
  delete optionsRoot.exitCallback;

  const intersectionObserver = new IntersectionObserver(
    (entries, observer) => executeInterception(
      entries, observer, { callback, exitCallback, unobserve }
    ),
    optionsRoot
  );

  intersectionObserver.observe(element);
};